import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import logo from "../../resources/logo.png";
import {
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Box } from "@mui/system";
import { Link, useNavigate } from "react-router-dom";
import { useUserAuthContext } from "../../context/UserAuthContext";
import dashboardIcons from "../../resources";

const Login = () => {
  const { logIn, googleSignin, forgotPassword } = useUserAuthContext();

  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");

  const [showPassword, setShowPassword] = useState(false); //for the icon in pass field

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const navigate = useNavigate();
  const loginSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await logIn(email, pass);
      navigate("/dashboard");
    } catch (err) {
      if (err.code === "auth/user-not-found") {
        setError("Incorrect Email! Please Check your email try again.");
      } else if (err.code === "auth/wrong-password") {
        setError("Incorrect password! Please try again.");
      } else {
        setError("Email or Password is invalid");
      }
    }
  };

  const handleGoogleLogin = async (e) => {
    e.preventDefault();
    try {
      await googleSignin();
      navigate("/dashboard");
    } catch (err) {
      setError(err.message);
    }
  };

  //foget pass, get email to reset it
  const sendForgotPassEmail = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await forgotPassword(email);
      navigate("/resetPassword");
    } catch (err) {
      console.log("Error code:", err.code)
      if (err.code === "auth/missing-email") {
        setError("Write Your Email First!");
      } else if(err.code === "auth/user-not-found"){
        setError("Your Email is not Registered to Pluuo AI!");
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className=" flex justify-center items-center overflow-hidden bg-gray-100">
      <Box className="p-12">
        <Link to="/">
        <img
          className=" mx-auto w-28 h-28 cursor-pointer"
          src={logo}
          alt="Pluuoai"
        /></Link>
        <h3 className="font-bold text-2xl leading-12 text-center my-5 mb-8">
          Welcome Back to Pluuo AI. <br />
          sign in here
        </h3>
        {error && (
          <p className="px-4 py-2 text-center text-red-500 text-lg font-medium">
            {error}
          </p>
        )}
        <form onSubmit={loginSubmit} className="flex flex-col px-4 w-96">
          <TextField
            id="outlined-basic"
            type="email"
            required
            label="Email Address"
            variant="outlined"
            sx={{marginBottom: 3}}
            onChange={(e) => setEmail(e.target.value)}
          />
          <FormControl variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              Password *
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              required
              type={showPassword ? "text" : "password"}
              label="Password *"
              onChange={(e) => setPass(e.target.value)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <Link
            onClick={sendForgotPassEmail}
            className=" text-blue-700 hover:text-blue-800 font-medium text-base mb-4"
          >
            Forgot Password?
          </Link>
          <button
            className="text-white font-bold py-2 rounded transform hover:scale-95 transition duration-300"
            style={{
              backgroundColor: "#333334",
              color: "#FFF27A",
              borderRadius: "2rem",
            }}
          >
            Login
          </button>
        </form>

        <hr className="border-gray-500 border-opacity-80 w-60 mx-auto my-4" />
        <div className="font-bold transform hover:scale-95 transition duration-300 mx-4">
          <div onClick={handleGoogleLogin} style={{
              width: "100%",
              backgroundColor: "#333334",
              borderRadius: "2rem",
              color: "#FFF27A",
              padding: "0.5rem 1rem",
            }} className=" flex justify-center gap-4 items-center cursor-pointer">
            <img className=" w-8 h-8 cursor-pointer" src={dashboardIcons.icons.google_icon} alt = "googleIcon" />
            <h4 className=" text-xl font-semibold">Login with Google</h4>
          </div>
        </div>
        <div className=" flex justify-around text-center mt-2">
          <h6 className=" font-medium text-sm ">
            Not have any account? <br />{" "}
            <Link className=" text-blue-700 font-medium text-base" to="/signup">
              SignUp
            </Link>{" "}
            here
          </h6>
        </div>
      </Box>
    </div>
  );
};

export default Login;
